import * as React from 'react';
import { useSelector } from 'react-redux';

import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

import { trackShowPhone } from '../../analytics/call';

import { CallBuilder } from '../../components/MobileCall/CallBuilder';
import { phoneToString } from '../../utils/phone/phoneToString';
import { gaLabelSelector } from 'shared/selectors/newbuilding';

interface ICallBuilderContainerProps {
  placeType?: string;
  target: INewbuildingBuilder | ISeller;
}
export const CallBuilderContainer: React.VFC<ICallBuilderContainerProps> = ({ placeType, target }) => {
  const gaLabel = useSelector(gaLabelSelector);

  const trackActionOpenContactsCall = React.useCallback(() => {
    trackShowPhone('Open_jk_card', gaLabel);
  }, [gaLabel, target]);

  const phone = phoneToString(target.phone);

  /* istanbul ignore next */
  if (!phone) {
    return null;
  }

  return (
    <CallBuilder
      siteBlockId={target.dynamicCalltracking?.siteBlockId}
      phone={phone}
      trackAction={trackActionOpenContactsCall}
      placeType={placeType}
    />
  );
};
